<template>
    <div>
        <div class="modal fade" id="attendance-create-modal" tabindex="-1" aria-labelledby="attendance-create-modal" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('new_check_in') }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                    </div>
                    <div class="modal-body" style="text-align:left">
                        <form @submit.prevent="save" class="check-in-form">
                            <div class="row">
                                <div class="col-sm-12 mb-3">
                                    <label class="form-label">{{ $t('client') }}</label>
                                    <auto-complete  
                                        @emitAutoCompleteClient="emitAutoCompleteClient" 
                                        v-if="createClientState === false" 
                                        :defaultValue="attendance.client?.name"
                                        entity="clients"
                                        :dislaySuggestions="true"
                                        emitEvent="emitAutoCompleteClient"
                                    ></auto-complete>
                                </div>
                                <div class="col-sm-12 mb-3">
                                    <collapsible-notes-field v-model="attendance.notes" id="attendance-notes" rows="1" />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ $t('close') }}</button>
                        <button type="button" class="btn btn-primary" @click="save" :disabled="loading || !isFormValid">{{ $t('check_in') }}</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import helper from '../helper';
import AutoComplete from './autocomplete/AutoComplete';

export default {
    name: 'AddAttendance',
    components: {
        AutoComplete,
    },
    props: ['state'],
    data() {
        return {
            attendance: {
                clientId: '',
                client: null,
                notes: ''
            },
            createModal: null,
            loading: false,
            createClientState: false
        };
    },
    computed: {
        isFormValid() {
            return this.attendance.clientId;
        }
    },
    mounted() {
        // eslint-disable-next-line no-undef
        this.createModal = new bootstrap.Modal(document.getElementById('attendance-create-modal'));
        if (this.state === true) {
            this.createModal.show();
        }

        document.getElementById('attendance-create-modal').addEventListener('hidden.bs.modal', () => {
            this.$emit('createAttendance', { state: false });
        });
    },
    methods: {
        async save() {
            try {
                this.loading = true;
                const response = await helper.customPost(`${process.env.VUE_APP_API}/attendance`, {
                    clientId: this.attendance.clientId,
                    checkIn: new Date().toISOString(),
                    notes: this.attendance.notes
                }, { showToast: true });
                this.loading = false;
                this.clearForm();
                this.$emit('createAttendance', { attendance: response.data, state: false });
                this.createModal.hide();
            } catch (error) {
                this.loading = false;
            }
        },
        clearForm() {
            this.attendance = {
                clientId: '',
                client: null,
                notes: ''
            };
        },
        emitAutoCompleteClient(data) {
            this.attendance.clientId = data.result.id;
            this.attendance.client = data.result;
        },
        openCreateClientModal() {
            this.createClientState = !this.createClientState;
        },
        createClient(data) {
            if (data.client) {
                this.attendance.clientId = data.client.id;
                this.attendance.client = data.client;
            }
            if (data && data.state != undefined) {
                this.createClientState = data.state;
            }
        }
    }
};
</script>
